import Comp from "./comp";
import Preview from "./preview";
import Desc from "./desc";
import dayjs from "dayjs";
console.log("1");
const Plugin = {
  name: "定制",
  render: Comp,
  board: Desc,
  preview: Preview,
  subPlugins: [],
  type: "haier-order",
  id: "id-haier-order", // 测试
  props: {
    banners: [
      {
        date: dayjs().format("YYYY/MM/DD"),
        activityName: "",
        activityGroup: [
          [
            {
              imageUrl:
                "//img12.360buyimg.com/zx/jfs/t1/261368/39/27806/163025/67c661c4F3145967a/b1c2526feccc6d51.png",
              jumpUrl: "",
              title: "",
              message: "",
              activity_id: "",
              time: "00:00:00",

              hotArea: [],
            },
            {
              imageUrl: "",
              jumpUrl: "",
              title: "",
              message: "",
              activity_id: "",
              time: "00:00:00",

              hotArea: [],
            },
          ],
          [
            {
              imageUrl: "",
              jumpUrl: "",
              title: "",
              message: "",
              activity_id: "",
              time: "00:00:00",

              hotArea: [],
            },
          ],
          [
            {
              imageUrl: "",
              jumpUrl: "",
              title: "",
              message: "",
              activity_id: "",
              time: "00:00:00",

              hotArea: [],
            },
          ],
        ],
      },
    ],
    singleImageWidth: 100,
    singleImageHeight: 100,
    between: 0,
    fallbackImage:
      "//img10.360buyimg.com/cms/jfs/t1/398320/33/20796/20022/69af6f81Fd3bb65b1/00831ec1e0fea349.png",
    newSkuCoverImage:
      "//img13.360buyimg.com/zx/jfs/t1/412818/28/19819/4341/69d63880Fdf3e1fd3/01f40b4050517ee4.png",
    liveCoverImage:
      "//img11.360buyimg.com/zx/jfs/t1/233957/10/23699/63305/6695d917F0ef3cc2e/b86782f132464ce6.png",
    activityCoverImage:
      "//img14.360buyimg.com/zx/jfs/t1/25131/38/20819/38310/6695d917F94cb828b/a5685dc4f0548be2.png",
  },
  extension: {
    struct: {
      date: dayjs().format("YYYY/MM/DD"),
      activityName: "",
      activityGroup: [
        [
          {
            imageUrl: "",
            jumpUrl: "",
            title: "",
            message: "",
            activity_id: "",
            time: "00:00:00",

            hotArea: [],
          },
          {
            imageUrl: "",
            jumpUrl: "",
            title: "",
            message: "",
            activity_id: "",
            time: "00:00:00",

            hotArea: [],
          },
        ],
        [
          {
            imageUrl: "",
            jumpUrl: "",
            title: "",
            message: "",
            activity_id: "",
            time: "00:00:00",

            hotArea: [],
          },
        ],
        [
          {
            imageUrl: "",
            jumpUrl: "",
            title: "",
            message: "",
            activity_id: "",
            time: "00:00:00",

            hotArea: [],
          },
        ],
      ],
    },
    hotArea: {
      width: 100,
      height: 100,
      left: 0,
      top: 0,
    },
    scrollWidthDuration: [0, 1125],
  },
  rectOptions: {
    width: 360,
    height: 480,
    left: 0,
    top: 0,
    rotate: 0,
    subRectOptions: [],
  },
  drawOptions: {
    resize: true,
    drag: true,
    rotate: false,
    keepRatio: false,
    subOptions: [],
    renderDirections: ["e"],
  },
};

export default Plugin;
